import Vue from 'vue'
import Router from 'vue-router'
import multiguard from 'vue-router-multiguard'

// Main Components
import NotFound from '@/components/Layouts/Main/NotFound'
import Before from '@/components/Layouts/Main/Before'
import Over from '@/components/Layouts/Main/Over'
import Rules from '@/components/Layouts/Main/Rules'

// Program Components
import Home from '@/components/Layouts/Program/Home'

import { generalMiddleware, getDatetimeMiddleware, beforeMiddleware, overMiddleware } from '@/router/middleware'

// Use router
Vue.use(Router)

// Non route component registering
Vue.component('navbar', require('@/components/Partials/Main/Navbar.vue').default)
Vue.component('footer-main', require('@/components/Partials/Main/FooterMain.vue').default)
Vue.component('general-header', require('@/components/Partials/Components/GeneralHeader.vue').default)
Vue.component('BackToTop', require('@/components/Partials/Components/BackToTop.vue').default)

// Program Non route components
Vue.component('rules-modal', require('@/components/Partials/Modals/RulesModal.vue').default)
Vue.component('rules-text', require('@/components/Rules/RulesText.vue').default)
Vue.component('enter-success-modal', require('@/components/Partials/Modals/EnterSuccessModal.vue').default)
Vue.component('multiple-chained-select', require('@/components/Partials/Components/MultipleChainedSelect.vue').default)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            name: 'notFound',
            component: NotFound,
            meta: {
                title: 'Not Found',
                partialType: 'meta'
            },
            beforeEnter: multiguard([generalMiddleware])
        },
        {
            path: '/before',
            name: 'before',
            component: Before,
            meta: {
                title: 'Before',
                partialType: 'meta'
            },
            beforeEnter: multiguard([generalMiddleware])
        },
        {
            path: '/over',
            name: 'over',
            component: Over,
            meta: {
                title: 'Over',
                partialType: 'meta'
            },
            beforeEnter: multiguard([generalMiddleware])
        },
        {
            path: '/rules',
            name: 'rules',
            component: Rules,
            meta: {
                title: 'Rules',
                partialType: 'meta'
            },
            beforeEnter: multiguard([generalMiddleware])
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'Tempur-Pedic',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, beforeMiddleware, overMiddleware])
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.afterEach((to, from) => {
    // End our vue-progressbar
    router.app.$Progress.finish()
})

export default router
